import { type FC } from 'react'
import { useIntl } from 'react-intl'

import { DialogTitle } from 'base-ui'

import { useCartIntermediateContext } from '../../hooks/useCartIntermediateContext'

type CartIntermediateTitleType = {
  handleClose: () => void
}
export const CartIntermediateTitle: FC<CartIntermediateTitleType> = ({
  handleClose,
}) => {
  const intl = useIntl()
  const { drawerMessages } = useCartIntermediateContext()
  const titleMessage = drawerMessages?.titleMessage

  return titleMessage ? (
    <DialogTitle
      className="bg-light-primary-medium"
      onClose={handleClose}
      slotProps={{
        closeButton: {
          'aria-label': intl.formatMessage({
            id: 'general.link.label.close',
          }),
        },
      }}
    >
      {titleMessage.message}
    </DialogTitle>
  ) : null
}
